import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as tabTypes from './tabTypes'
import RoutesHelper from 'helpers/RoutesHelper'

import SettingVerticalTabs from 'components/Utils/SettingVerticalTabs'

const TABS = [
  tabTypes.PROFILE,
  tabTypes.INFORMATIONS,
  tabTypes.ANALYTICS,
  tabTypes.USERS,
  tabTypes.USER_GROUPS,
  tabTypes.INVITATIONS,
  tabTypes.AUTHENTICATION,
  tabTypes.BILLING,
  tabTypes.CHANNELS,
  tabTypes.INTEGRATIONS,
  tabTypes.FLAGS,
]

class Menu extends Component {
  render() {
    const { tab: currentTabId, tabs, options } = this.props
    const defaultTabId = tabTypes.INFORMATIONS.id

    const enhancedTabs = tabs.map(tab => {
      const isActive = tab ? currentTabId === tab.id : tab.id === defaultTabId
      const link = RoutesHelper.settingsOrganization({ tabId: tab.id })
      const subTabs = tab.subTabs
        ? tab.subTabs.map((subTab, index) => {
            const idMatch = options === subTab.id
            const isIndex = !options && index === 0
            return {
              ...subTab,
              isActive: idMatch || isIndex,
              link: RoutesHelper.settingsOrganization({
                tabId: tab.id,
                options: subTab.id,
              }),
            }
          })
        : null
      return {
        ...tab,
        isActive,
        link,
        subTabs,
      }
    })
    return (
      <div
        className="flexbox flexbox-column border-right-medium border-shade-50 height-full-page padding-top-large"
        style={{ minWidth: 239 }}
      >
        <SettingVerticalTabs tabs={enhancedTabs} />
      </div>
    )
  }
}

export default connect((state, { options }) => {
  // TODO: This needs to be optimized, heavily
  const tabs = TABS.filter(function filterOutTabs(tab) {
    return tab.shouldDisplay(state)
  }).map(function filterOutSubTabs(tab) {
    if (!tab.subTabs) {
      return tab
    }

    return {
      ...tab,
      subTabs: tab.subTabs.filter(subTab => subTab.shouldDisplay(state)),
    }
  })
  return { tabs }
})(Menu)
